import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
    selector: 'fm-logo-link',
    imports: [RouterModule],
    templateUrl: './logo-link.component.html',
    styleUrl: './logo-link.component.scss',
})
export class LogoLinkComponent {}
